import React from 'react'
import HelpPageForm, { FormMode } from '../components/HelpPageForm'
import { useTranslation } from 'react-i18next'

const EditHelpPage: React.FC = () => {
  const { t } = useTranslation()

  return (
    <>
      <HelpPageForm title={t('HelpPage:form.label.editHelpPage')} mode={FormMode.edit} />
    </>
  )
}

export default EditHelpPage
